import type React from 'react';

import type { StateLabel } from './stateInfo';

interface HoveredLabelProps {
  stateLabel: StateLabel;
  color: string;
}

const HoveredLabel: React.FC<HoveredLabelProps> = ({ stateLabel, color }) => (
  <>
    <rect
      x={8}
      y={8}
      width={stateLabel.rectangleWidth}
      height='35'
      r={5}
      rx={5}
      ry={5}
      fill='#ffffff'
      stroke={color}
      strokeWidth='2px'
      opacity={1}
      style={{
        WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',
        opacity: 1,
        strokeLinejoin: 'miter',
        strokeLinecap: 'square',
      }}
      strokeLinejoin='miter'
      strokeLinecap='square'
      transform={stateLabel.transform}
    />
    <text
      x={stateLabel.xTextPosition}
      y='25'
      textAnchor='middle'
      stroke='none'
      fill='#000000'
      style={{
        WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',
        textAnchor: 'middle',
        font: '16px Roobert',
        opacity: 1,
      }}
      fontSize='16px'
      fontFamily='Roobert'
      opacity={1}
      transform={stateLabel.transform}
    >
      <tspan
        dy='6.178406715393066'
        style={{ WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)' }}
      >
        {stateLabel.stateName}
      </tspan>
    </text>
  </>
);

export default HoveredLabel;
